import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-resultpage',
  templateUrl: './resultpage.component.html',
  styleUrls: ['./resultpage.component.css']
})
export class ResultpageComponent implements OnInit {
  configList = {};
  site = '';
  messgeList = '';
  constructor(
    private router: Router,
    private http: HttpClient,

  ) { }

  async ngOnInit() {
    this.configList = await this.http.get('./assets/config/remindText.json').toPromise();
    this.site = this.configList['site'];
    if (this.site === 'WCD') {
      this.messgeList = this.configList['resultTip1'];
    } else if (this.site === 'WCQ') {
      this.messgeList = this.configList['resultTip2'];
    }
  }
  gobackHome() {
    this.router.navigateByUrl('/homepage');
  }
}
